<template>
  <sdk-input @blur="onBlur" @focus="onFocus" @input="onInput" :maxlength="4" :style="inputStyle" :placeholder="placeholder" />
</template>
<script>
import SdkInput from '@/views/sdk/components/sdk-input.vue'
import { onSecurityCodeInput, rules } from '@/utils/tools/checkout'
import { sendMessageToClient, getFormatMessage, encryptData } from '@/views/sdk/tools'

export default {
  name: 'card-code',
  components: { SdkInput },
  data() {
    return {
      inputValue: '',
      options: {},
      isError: false,
      inputStyle: {},
      placeholder: ''
    }
  },
  created() {
    window.addEventListener('message', this.listeningMessage)
  },
  methods: {
    listeningMessage(messageData) {
      const { event, data } = getFormatMessage(messageData, this.$route) || {}
      switch (event) {
        case 'sdk_checkout__settings': {
          this.options = data
          this.inputStyle = data?.inputStyle || {}
          this.placeholder = data?.inputPlaceholder?.securityCode || ''
          break
        }
        case 'sdk_checkout__validator': {
          this.sendErrorMessage(
            this.inputValue,
            () => {
              sendMessageToClient(
                'sdk_checkout__code_prepare',
                { cvv: encryptData(this.inputValue, this.options?.verificationData?.key, this.options?.verificationData?.iv) },
                this.$route
              )
            },
            () => {
              sendMessageToClient('sdk_checkout__code_prepare', { cvv: '' }, this.$route)
            }
          )
          break
        }
      }
    },
    sendErrorMessage(value, onSuccess, onError) {
      rules.cvv(null, value, (error, typeCode) => {
        this.isError = !!error
        if (this.isError) {
          sendMessageToClient('sdk_checkout__form_verify', { typeCode }, this.$route)
          if (onError) {
            onError()
          }
        } else {
          sendMessageToClient('sdk_checkout__form_verify', { typeCode: '15050' }, this.$route)
          if (onSuccess) {
            onSuccess()
          }
        }
      })
    },
    onInput(event) {
      event.target.value = onSecurityCodeInput(event)
      this.inputValue = event.target.value
      if (this.options.errorTrigger === 'change') {
        this.sendErrorMessage(this.inputValue)
      }
      sendMessageToClient('sdk_checkout__style_event_change', { type: 'security_code_change' }, this.$route)
    },
    onFocus() {
      sendMessageToClient('sdk_checkout__style_event_change', { type: 'security_code_focus' }, this.$route)
    },
    onBlur() {
      sendMessageToClient('sdk_checkout__style_event_change', { type: 'security_code_blur' }, this.$route)
      if (this.options.errorTrigger === 'blur') {
        this.sendErrorMessage(this.inputValue)
      }
    }
  },
  watch: {
    '$store.getters.app.currentLan': 'onLanguageChange'
  }
}
</script>
<style lang="less">
@import '~@/styles/common.less';
</style>
